import { Theme } from '@mui/material/styles'

import DefaultTheme from './DefaultTheme'
import CircaTheme from './CircaTheme'

export { DefaultTheme, CircaTheme }

const findTheme = (themeName: string | null | undefined): Theme => {
  switch (themeName) {
    case 'circa':
      return CircaTheme
    default:
      return DefaultTheme
  }
}

export { findTheme }
